import { CalendarMonth } from '@mui/icons-material';
import PropTypes from 'prop-types';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { modeTravailEnum, regimeTravailEnum } from '../../data/Interfaces';
import useWindowSize from '../../hooks/useWindowSize';
import { IconTextField, SelectComponent } from './ReusableSmallComponents';

const RegimeModeTravail = ({mode, modeTravail, regimeTravail,setCheckUpdateValue,setRegimeTravail,setModeTravail}) => {

    RegimeModeTravail.propTypes = {
        modeTravail: PropTypes.any.isRequired,
        mode: PropTypes.any,
        regimeTravail: PropTypes.any.isRequired,
        setCheckUpdateValue:PropTypes.func,
        setRegimeTravail: PropTypes.func.isRequired,
        setModeTravail: PropTypes.func.isRequired,

        // isRequired: PropTypes.bool,
        // isValid: PropTypes.bool,
        // setIsValid: PropTypes.func,
    };

    const {device}=useWindowSize();
    const { i18n } = useTranslation();
    // const [isValidIntern] = useFormValidation([
    //     { name: 'modeTravail', value: modeTravail },
    //     { name: 'regimeTravail', value: regimeTravail },
    // ]);
    // useEffect(() => {
    //     if(isRequired){
    //         console.log('444', isValidIntern);
    //         setIsValid(isValidIntern);
    //     }
    // }, [isValidIntern]);

    const handleChangeRegimeTravail = (prop) => (event) => {
        //const newValue=event.target.value;
        //if(prop=='nbJrsPartielPerWeek' || prop=='nbJrsRemotePerWeek')
        //{
        //    if (newValue === '' || (newValue >= 1 && newValue <= 4)) {
        //        setError(false);
        //    } else {
        //        setError(true);
        //    }
        //}
        setRegimeTravail({ ...regimeTravail, [prop]: event.target.value });
        if(setCheckUpdateValue)
            setCheckUpdateValue(false);
    };

    const handleChangeModeTravail = (prop) => (event) => {
        setModeTravail({ ...modeTravail, [prop]: event.target.value });
        if(setCheckUpdateValue)
            setCheckUpdateValue(false);
    };
    // console.log('regimeTravail',regimeTravail);

    const handleKeyDown = (event) => {
        if (event.key === '-') {
            event.preventDefault();
        }
    };

    //const handleKeyPress = (event) => {
    //    const key = event.key;
    //    if (!(key >= 1 && key <= 4)) {
    //        alert('Please enter a number between 1 and 4');
    //    }
    //};

    //const [error, setError] = React.useState(false);

    return (
        <>
            <div className='B1Pub1'>
                <div
                    className='Frame10129'
                    style={{width:device=='desktop'?'50%':'100%'}}
                >
                    <p className='IntitulePoste'>{i18n.t('Régime de travail')}</p>
                    <SelectComponent
                        val={regimeTravail?.type}
                        name='regimeTravail'
                        disabled={mode=='readOnly' ? true : false}
                        setVal={(event) => {
                            if(event.target.value == 'temps-partiel'){
                                setRegimeTravail({type: event.target.value ,nbJrsPartielPerWeek: '' });
                                if(setCheckUpdateValue)
                                    setCheckUpdateValue(false);
                            }
                            else{
                                setRegimeTravail({ ...regimeTravail, ['type']: event.target.value });
                                if(setCheckUpdateValue)
                                    setCheckUpdateValue(false);
                            }
                        }}
                        listVal={regimeTravailEnum}
                    />
                    {/*<p className='IntitulePoste'>Régime de mission</p>
                    <ThemeProvider theme={FieldComponentFont}>
                        <FormControl
                            className='clo-6'
                            style={{width:'100%'}}
                        >
                            <Select
                                labelId="demo-multiple-name-label"
                                id="demo-multiple-name"
                                variant="focused"
                                displayEmpty
                                size={inputSize}
                                input={<OutlinedInput />}
                                MenuProps={MenuProps}
                                value={regimeTravail?.type}
                                onChange={handleChangeRegimeTravail('type')}
                                name="regimeTravail"
                                autoComplete="off"
                                style={{background:'white'}}
                                sx={{
                                    '& > :not(style)': {borderRadius: '8px'},
                                }}
                            >
                                {regimeTravailEnum.map((option) => (
                                    <MenuItem
                                        key={option.value}
                                        value={option.value}
                                    >{option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </ThemeProvider>*/}

                </div>
                <div
                    className='Frame10129'
                    style={{width:device=='desktop'?'50%':'100%'}}
                >
                    <p className='IntitulePoste'>{i18n.t('Nombre de jours (si temps partiel)')}</p>
                    {/* select 1/Semaine --> 4*/}
                    <IconTextField
                        id="outlined-start-adornment"
                        sx={{'& > :not(style)': {borderRadius: '8px' } }}
                        style={{width:'100%',borderRadius: '8px'}}
                        iconStart={<CalendarMonth />}
                        InputProps={{
                            inputProps: { min: 1, max: 4 },
                            //startAdornment: (
                            //    <div className='iconStyleStartAdornment'>
                            //        <InputAdornment
                            //            position="start"
                            //        >
                            //            <CalendarMonth />
                            //        </InputAdornment>
                            //    </div> // Close the div properly
                            //)
                        }}
                        type="number"
                        name="nbJrsPartielPerWeek"
                        value={regimeTravail?.nbJrsPartielPerWeek}
                        error={!(regimeTravail?.nbJrsPartielPerWeek > 0 && regimeTravail?.nbJrsPartielPerWeek < 5)}
                        helperText={(regimeTravail?.nbJrsPartielPerWeek ? ((regimeTravail?.nbJrsPartielPerWeek > 0 && regimeTravail?.nbJrsPartielPerWeek < 5) ? '' :'Entrez une valeur entre 1 et 4'):'')}
                        onKeyDown={handleKeyDown}
                        onChange={handleChangeRegimeTravail('nbJrsPartielPerWeek')}
                        disabled={(mode=='readOnly' ||(mode!='readOnly' && regimeTravail?.type != 'temps-partiel')) ? true : false}
                    />
                </div>
            </div>
            <div className='B1Pub1'>
                <div
                    className='Frame10129'
                    style={{width:device=='desktop'?'50%':'100%'}}
                >
                    <p className='IntitulePoste'>{i18n.t('Mode de travail')}</p>
                    <SelectComponent
                        //label={'Mode de travail'}
                        val={modeTravail?.type}
                        name='modeTravail'
                        setVal={(event) => {
                            if(event.target.value != 'hybride'){
                                setModeTravail({type: event.target.value ,nbJrsRemotePerWeek: '' });
                                if(setCheckUpdateValue)
                                    setCheckUpdateValue(false);
                            }
                            else{
                                setModeTravail({ ...modeTravail, ['type']: event.target.value });
                                if(setCheckUpdateValue)
                                    setCheckUpdateValue(false);
                            }
                        }}
                        disabled={mode=='readOnly' ? true : false}
                        listVal={modeTravailEnum}
                    />
                </div>
                <div
                    className='Frame10129'
                    style={{width:device=='desktop'?'50%':'100%'}}
                >
                    <p className='IntitulePoste'>{i18n.t('Fréquenece (télétravail)')}</p>
                    {/*1/Semaine --> 4*/}
                    <IconTextField
                        id="outlined-start-adornment"
                        sx={{'& > :not(style)': {borderRadius: '8px' }}}
                        style={{width:'100%',borderRadius: '8px'}}
                        iconStart={ <CalendarMonth/>}
                        InputProps={{
                            //startAdornment: <InputAdornment position="start">
                            //    <CalendarMonth/>
                            //</InputAdornment>,
                            inputProps: { min: 1, max: 4 }
                        }}
                        type="number"
                        name="nbJrsRemotePerWeek"
                        value={modeTravail?.nbJrsRemotePerWeek}
                        error={(modeTravail?.nbJrsRemotePerWeek >0 && modeTravail?.nbJrsRemotePerWeek<5) ? false : true}
                        helperText={(modeTravail?.nbJrsRemotePerWeek ? ((modeTravail?.nbJrsRemotePerWeek >0 && modeTravail?.nbJrsRemotePerWeek<5) ? '' :i18n.t('Entrez une valeur entre 1 et 4')):'')}
                        onKeyDown={handleKeyDown}
                        onChange={handleChangeModeTravail('nbJrsRemotePerWeek')}
                        autoComplete="off"
                        disabled={(mode=='readOnly' ||(mode!='readOnly' && modeTravail?.type != 'hybride')) ? true : false}
                    />
                </div>
            </div>
        </>
    );
};

export default RegimeModeTravail;

// * Using Selects:
{/*<TextFieldComponent
                        id="outlined-start-adornment"
                        sx={{'& > :not(style)': {borderRadius: '8px' } }}
                        style={{width:'100%',borderRadius: '8px'}}
                        InputProps={{
                            inputProps: { min: 1, max: 4 },
                            startAdornment: (
                                <div style={{ backgroundColor: 'white' }}>
                                    <InputAdornment
                                        position="start"
                                        style={{ backgroundColor: 'white' }} // Add this line
                                    >
                                        <CalendarMonth />
                                    </InputAdornment>
                                <div>
                            )
                        }}
                        type="number"
                        name="nbJrsPartielPerWeek"
                        value={regimeTravail?.nbJrsPartielPerWeek}
                        error={(regimeTravail?.nbJrsPartielPerWeek >0 && regimeTravail?.nbJrsPartielPerWeek<5) ? false : true}
                        helperText={(regimeTravail?.nbJrsPartielPerWeek ? ((regimeTravail?.nbJrsPartielPerWeek >0 && regimeTravail?.nbJrsPartielPerWeek<5) ? '' :'Entrez une valeur entre 1 et 4'):'')}
                        onKeyDown={handleKeyDown}
                        onChange={handleChangeRegimeTravail('nbJrsPartielPerWeek')}
                        //onInput={handleChangeRegimeTravail('nbJrsPartielPerWeek')}
                        disabled={(mode=='readOnly' ||(mode!='readOnly' && regimeTravail?.type != 'temps-partiel')) ? true : false}
                    />*/}

{/*<p className='IntitulePoste'>Mode de travail</p>
                    <ThemeProvider theme={FieldComponentFont}>
                        <FormControl
                            className='clo-6'
                            style={{width:'100%'}}
                        >
                            <Select
                                labelId="demo-multiple-name-label"
                                id="demo-multiple-name"
                                displayEmpty
                                variant="focused"
                                size={inputSize}
                                input={<OutlinedInput />}
                                MenuProps={MenuProps}
                                value={modeTravail?.type}
                                onChange={handleChangeModeTravail('type')}
                                name="modeTravail"
                                autoComplete="off"
                                style={{width:'100%'}}
                                sx={{
                                    '& > :not(style)': {borderRadius: '8px'},
                                }}
                            >
                                {modeTravailEnum.map((option) => (
                                    <MenuItem
                                        key={option.value}
                                        value={option.value}
                                    >{option.label}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </ThemeProvider>*/}
// * AIDA's version:

{/*<div className='frame7preference'>
                            <div className='frame8preference'>
                                <div className='frame9preference'>
                                    <div className='frame09preference'>
                                        <SelectComponent
                                            val={mode}
                                            setVal={(event) => {
                                                if (!CompareTwoString(event.target.value, firstDataFromBackend?.preference?.modeTravail?.type)) {
                                                    setCheckUpdateValue(false);
                                                }
                                                setMode(event.target.value);
                                                if (event.target.value != 'hybride')
                                                    setTempsjour('');
                                            }}
                                            disabled={role == 'admin' ? true : false}
                                            listVal={modeTravailEnum}
                                        />

                                        <ThemeProvider theme={FieldComponentFont}>
                                            <Select
                                                labelId="demo-simple-select-label"
                                                id="demo-simple-select"
                                                ////size="small"
                                                value={mode}
                                                //label="Age"
                                                disabled={role == 'admin' ? true : false}
                                                sx={{
                                                    '& > :not(style)': { borderRadius: '8px' },
                                                }}
                                                style={{ background: 'white' }}
                                                onChange={(event) => {
                                                    if (!CompareTwoString(event.target.value, firstDataFromBackend?.preference?.modeTravail?.type)) {
                                                        setCheckUpdateValue(false);
                                                    }
                                                    setMode(event.target.value);
                                                    if (event.target.value != 'hybride')
                                                        setTempsjour('');
                                                }}
                                            >
                                                {modeTravailEnum.map((option) => (
                                                    <MenuItem
                                                        key={option.value}
                                                        value={option.value}
                                                    >{option.label}
                                                    </MenuItem>
                                                ))}
                                            </Select>
                                        </ThemeProvider>
                                    </div>
                                    <div className='frame009preference'>
                                        <SelectComponent
                                            val={mode}
                                            setVal={(event) => {
                                                if (!CompareTwoString(event.target.value, firstDataFromBackend?.preference?.modeTravail?.type)) {
                                                    setCheckUpdateValue(false);
                                                }
                                                setMode(event.target.value);
                                                if (event.target.value != 'hybride')
                                                    setTempsjour('');
                                            }}
                                            disabled={role == 'admin' ? true : false}
                                            listVal={modeTravailEnum}
                                        />

                                        <label className='labelframe8preference'>Fréquence de télé-travail</label>
                                        <SelectComponent
                                            val={tempsjour}
                                            setVal={(event) => {
                                                if (!CompareTwoString(event.target.value, firstDataFromBackend?.preference?.modeTravail?.nbJrsRemotePerWeek)) {
                                                    console.log('nbjrRemotePerWeek');
                                                    setCheckUpdateValue(false);
                                                }
                                                setTempsjour(event.target.value);
                                            }}
                                            disabled={(mode == 'presentiel' || mode == 'remote' || mode == 'indifferent' || role == 'admin') ? true : false}
                                            listVal={modeTravailEnum}
                                        />

                                        <FormControl
                                            style={{ width: '100%' }}
                                            size={inputSize}
                                        >
                                            <label className='labelframe8preference'>Fréquence de télé-travail</label>
                                            <ThemeProvider theme={FieldComponentFont}>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={tempsjour}
                                                    defaultValue=''
                                                    disabled={(mode == 'presentiel' || mode == 'remote' || mode == 'indifferent' || role == 'admin') ? true : false}
                                                    sx={{
                                                        '& > :not(style)': { borderRadius: '8px' },
                                                    }}
                                                    style={{ background: 'white' }}
                                                    onChange={(event) => {
                                                        if (!CompareTwoString(event.target.value, firstDataFromBackend?.preference?.modeTravail?.nbJrsRemotePerWeek)) {
                                                            console.log('nbjrRemotePerWeek');
                                                            setCheckUpdateValue(false);
                                                        }
                                                        setTempsjour(event.target.value);
                                                    }}
                                                >
                                                    <MenuItem value={'1'}>1j/semaine</MenuItem>
                                                    <MenuItem value={'2'}>2j/semaine</MenuItem>
                                                    <MenuItem value={'3'}>3j/semaine</MenuItem>
                                                    <MenuItem value={'4'}>4j/semaine</MenuItem>
                                                </Select>
                                            </ThemeProvider>
                                        </FormControl>
                                    </div>
                                </div>
                                <div className='frame0009preference'>
                                    <div className='frame09preference'>
                                        <FormControl
                                            style={{ width: '100%' }}
                                            size={inputSize}
                                        >
                                            <label className='label2frame8preference'>Régime de travail</label>
                                            <ThemeProvider theme={FieldComponentFont}>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={temps}
                                                    defaultValue=''
                                                    ////size="small"
                                                    //label="Age"
                                                    disabled={role == 'admin' ? true : false}
                                                    sx={{
                                                        '& > :not(style)': { borderRadius: '8px' },
                                                    }}
                                                    style={{ background: 'white' }}
                                                    onChange={(event) => {
                                                        if (!CompareTwoString(event.target.value, firstDataFromBackend?.preference?.dateDisponibilite)) {
                                                            setCheckUpdateValue(false);
                                                        }
                                                        setTemps(event.target.value);
                                                        if (event.target.value == 'temps-plein')
                                                            setTempsjourTP('');
                                                    }}
                                                >
                                                    {regimeTravailEnum
                                                        .map((option) => (
                                                            <MenuItem
                                                                key={option.value}
                                                                value={option.value}
                                                            >{option.label}
                                                            </MenuItem>
                                                        ))}
                                                </Select>
                                            </ThemeProvider>
                                        </FormControl>
                                    </div>
                                    <div className='frame009preference'>
                                        <FormControl
                                            style={{ width: '100%' }}
                                            size={inputSize}
                                        >
                                            <label className='label2frame8preference'>Si temps partiel, nombre des jours</label>
                                            <ThemeProvider theme={FieldComponentFont}>
                                                <Select
                                                    labelId="demo-simple-select-label"
                                                    id="demo-simple-select"
                                                    value={tempsjourTP}
                                                    //label="Age"
                                                    defaultValue=''
                                                    disabled={(temps == 'temps-plein' || role == 'admin') ? true : false}
                                                    sx={{
                                                        '& > :not(style)': { borderRadius: '8px' },
                                                    }}
                                                    style={{ background: 'white' }}
                                                    onChange={(event) => {
                                                        if (!CompareTwoString(event.target.value, tempsjourTP)) {
                                                            setCheckUpdateValue(false);
                                                        }
                                                        setTempsjourTP(event.target.value);
                                                    }}
                                                >
                                                    <MenuItem value={'1'}>1j/semaine</MenuItem>
                                                    <MenuItem value={'2'}>2j/semaine</MenuItem>
                                                    <MenuItem value={'3'}>3j/semaine</MenuItem>
                                                    <MenuItem value={'4'}>4j/semaine</MenuItem>
                                                </Select>
                                            </ThemeProvider>
                                        </FormControl>
                                    </div>
                                </div>
                            </div>
                        </div>*/}